// extracted by mini-css-extract-plugin
export default {"virtual":"Virtual_virtual__o6FKS","left":"Virtual_left__YNhsQ","wrapperCompare":"Virtual_wrapperCompare__XrvU6","right":"Virtual_right__oUQis"};